import '../../../stylesheets/themes/contact.css'
import { getRegion }  from '@/utils/common'

const ERROR_MESSAGES = {
  REQUIRED: '*Please enter %s.',
  INVALID_KANA: '*Please enter in Katakana.',
  INVALID_TEL_MY: '*Please enter a valid Malaysian phone number',
  INVALID_TEL_SG: '*Please enter a valid Singaporean phone number',
  INVALID_EMAIL: '*Please enter a valid email address.',
  INVALID_PURPOSE: '*Please select the purpose of your inquiry.'
}

class ContactFormValidator {
  submitButton: HTMLButtonElement | null
  submitForm: HTMLFormElement | null
  isValid = true

  constructor() {
    this.submitButton = document.getElementById('submit-contact-form') as HTMLButtonElement
    this.submitForm = document.getElementById('contact-form') as HTMLFormElement
    this.bindEvents()
  }

  getRequiredErrorMessage(inputName: string) {
    return ERROR_MESSAGES.REQUIRED.replace(/%s/, inputName)
  }

  bindErrorMessage(elm: HTMLDivElement, errors: string[]) {
    if (errors.length > 0) {
      elm.innerHTML = errors.join('<br>')
      this.isValid = false
    }
  }

  isEmpty(value: string | undefined) {
    return value === undefined || value === ''
  }

  validateFullName() {
    const fullName = document.querySelector('#contact-form-input-fullName') as HTMLInputElement
    const error = document.querySelector('.contact-form-field-errorMessage.fullName') as HTMLDivElement
    if (!fullName || !error) return false

    const errorMessages = []
    if (this.isEmpty(fullName.value)) {
      errorMessages.push(this.getRequiredErrorMessage('Full Name'))
    }
    this.bindErrorMessage(error, errorMessages)
  }

  validateTel() {
    const tel = document.querySelector('#contact-form-input-tel') as HTMLInputElement
    const error = document.querySelector(
      '.contact-form-field-errorMessage.tel'
    ) as HTMLDivElement

    if (!tel || !error) return false

    const errorMessages = []
    const myPhoneRegex = new RegExp(/^(\+60|0)?[1-9]\d{7,9}$/)
    const sgPhoneRegex = new RegExp(/^(\+65|0)?[1-9]\d{7}$/) //altered starting digit after country code
    const phoneRegex = getRegion()?.region === 'sg' ? sgPhoneRegex : myPhoneRegex
    const invalidTelMsg = getRegion()?.region === 'sg' ? ERROR_MESSAGES.INVALID_TEL_SG : ERROR_MESSAGES.INVALID_TEL_MY
    if (!this.isEmpty(tel.value) &&  !phoneRegex.test(tel.value)) {
      errorMessages.push(invalidTelMsg)
    }
    this.bindErrorMessage(error, errorMessages)
  }

  validateEmail() {
    const email = document.querySelector('#contact-form-input-email') as HTMLInputElement
    const error = document.querySelector(
      '.contact-form-field-errorMessage.email'
    ) as HTMLDivElement

    if (!email || !error) return false

    const errorMessages = []

    if (this.isEmpty(email.value)) {
      errorMessages.push(this.getRequiredErrorMessage('Email Address'))
    } else if (!email.checkValidity()) {
      errorMessages.push(ERROR_MESSAGES.INVALID_EMAIL)
    }

    this.bindErrorMessage(error, errorMessages)
  }

  validatePurpose() {
    const purpose = document.querySelector('#contact-form-input-purpose') as HTMLInputElement
    const error = document.querySelector(
      '.contact-form-field-errorMessage.purpose'
    ) as HTMLDivElement

    if (!purpose || !error) return

    const errorMessages = []

    if (this.isEmpty(purpose.value)) {
      errorMessages.push(ERROR_MESSAGES.INVALID_PURPOSE)
    }

    this.bindErrorMessage(error, errorMessages)
  }

  validateContent() {
    const content = document.querySelector('#contact-form-input-content') as HTMLInputElement
    const error = document.querySelector(
      '.contact-form-field-errorMessage.content'
    ) as HTMLDivElement

    if (!content || !error) return

    const errorMessages = []

    if (this.isEmpty(content.value)) {
      errorMessages.push(this.getRequiredErrorMessage('Inquiry Content'))
    }

    this.bindErrorMessage(error, errorMessages)
  }

  submitHandler() {
    this.isValid = true
    const allErrors = document.querySelectorAll('.contact-form-field-errorMessage')
    allErrors.forEach(errorMessage => errorMessage.innerHTML = '')

    this.validateFullName()
    this.validateTel()
    this.validateEmail()
    this.validatePurpose()
    this.validateContent()
    if (this.isValid && this.submitForm) {
      this.submitForm.submit()    }
  }


  bindEvents() {
    this.submitButton?.addEventListener('click', () => this.submitHandler())
  }
}

document.addEventListener('DOMContentLoaded', function() {
  try {
     new ContactFormValidator()
  } catch (e) { }
})
